import { invariant } from "@rekajs/utils";
import * as React from "react";
import { EditorContext } from "./editor-context-provider";
export const useMaybeEditor = () => {
    const editorContext = React.useContext(EditorContext);
    if (!(editorContext === null || editorContext === void 0 ? void 0 : editorContext.editor)) {
        throw new Error("Editor not found");
    }
    return editorContext.editor;
};
export const useEditor = () => {
    const editor = useMaybeEditor();
    invariant(editor, "Editor not found");
    return editor;
};
